import * as React from 'react';
import { d3EmployeeAgencyChart } from '../../../interface/MyInterfaces';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend,ResponsiveContainer } from 'recharts'
import renderHTML from 'react-render-html';
import ZoomHelp from "./ZoomHelp";

interface ChartState {
    sortkey?: string;
}

export class EmployeeAgencyChart extends React.Component<d3EmployeeAgencyChart, ChartState> {
    constructor(props) {
        super(props);
        this.state = { sortkey: "" };
        this.doSort = this.doSort.bind(this);
    }

    doSort(event) {
        let key = event.dataKey;
        this.setState({
            sortkey: key
        });
    }

    onBarClick = (item) => {
        if (item != null && item.title != undefined) {
            var title = item.title;
            this.setState({
                sortkey: title
            });
        }
    }

    chartText() {
        var text = "";
        if (this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart2_text && this.props.SpendingReport_Tab1.chart2_text != "") {
            text = renderHTML(this.props.SpendingReport_Tab1.chart2_text);
        }
        return <div>
            {text}
        </div>
    }

    render() {
        let data = this.props.SpendingEmployeeAgencyChart_Data;//this.formatData();

        if (this.props.SpendingEmployeeAgencyChart_Data !== undefined) {
            const postgradexists = this.props.SpendingEmployeeAgencyChart_Data.filter(x => x["Post Graduate Researcher"] != 0);

            if (postgradexists.length == 0) {
                data.forEach(x => {
                    delete x["Post Graduate Researcher"]
                })
            }
        }

        let width = (this.props.normal_or_large == 0) ? 500 : 800;
        let height = (this.props.normal_or_large == 0) ? 450 : 650;
        let margin = (this.props.normal_or_large == 0) ? { top: 20, right: 15, left: 50, bottom: 35 } :
            { top: 5, right: 20, left: 75, bottom: 45 };
        let the_fontsize = (this.props.normal_or_large == 0) ? 11 : 14;
        let yaxis_xpos = (this.props.normal_or_large == 0) ?-55 : -75;
        let iconSize = (this.props.normal_or_large == 0) ? 14 : 24;
        if (this.props.SpendingEmployeeAgencyChart === undefined)
            return <div>loading..</div>
        else {
            var chart_title = this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart2_chart_title;
            const chartContent = (
                <>
                    {this.props.normal_or_large == 0 && <h5>{chart_title}</h5>}
                    {this.props.normal_or_large == 1 && <h2>{chart_title}</h2>}
                    <div className="spending-export-chart-area" style={{ width, height }}>
                        <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data}
                            layout={"vertical"}
                            margin={margin}
                            onClick={this.onBarClick}
                        >
                            <XAxis
                                tickFormatter={(value) => { return parseInt(value) + "%"; }}
                                domain={[0, 100]} type="number" tick={{ fontSize: the_fontsize }} />
                            <YAxis
                                label={{ value: "agency (employee count)", angle: -90, dx: yaxis_xpos, fontSize: the_fontsize }}
                                dataKey="agy" type="category"
                                tick={{ fontSize: the_fontsize }} />
                            <Tooltip formatter={(value) => { return value.toFixed(1) + "%"; }} />
                            <Legend iconSize={iconSize} align={"left"} onClick={this.doSort} />
                            {data && this.renderBars(data)}
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </>
            );
            return (
                <div style={{height:'100%'}}>
                    <div>
                        {this.props.normal_or_large == 1 && <ZoomHelp className="zoomhelp zoomed" chart_no={2} />}
                        {this.props.normal_or_large == 0 && this.chartText()}
                        {this.props.exportTargetId
                            ? <div id={this.props.exportTargetId} className="spending-export-block">
                                {chartContent}
                            </div>
                            : chartContent}
                    </div>
                </div>
            );
        }
    }
    renderBars(data) {
        const fill = ["#c1d7d8", "#8884d8", "#82ca9d", "#3a508a", "#b6d957", "#fac364", "#8cd3ff", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8", "#52bacc", "#dbdb46", "#98aafb"];
        var titles_remove_agy = Object.keys(data[0]).filter((obj, index) => { return (obj != "agy"); });
        var titles = titles_remove_agy.map((obj, index) => { return { title: obj, fill: fill[index] }; });
        var sortedtitles = [];
        //arrange the list to show clicked legend title first
        if (this.state.sortkey != "") {
            sortedtitles = titles.filter((value) => { return (this.state.sortkey == value["title"]); }) // first put value sorted on
            // then put remaining values
            titles.forEach((value) => {
                if (this.state.sortkey != value["title"])
                    sortedtitles.push(value);
            });
        }
        else {
            sortedtitles = titles;
        }
        return sortedtitles.map((item, index) => {
            return <Bar key={index} dataKey={item.title} stackId="a" fill={item.fill} onClick={() => this.onBarClick(item)}></Bar>
        });
    }
}
